// Lightweight wrappers around the TikTok Pixel and Google Analytics gtag
// installed in /app/frontend/public/index.html. Calls are no-ops when the
// underlying scripts haven't loaded yet (e.g. ad blockers).

export function ttqTrack(event, params = {}) {
  try {
    if (typeof window !== "undefined" && window.ttq && typeof window.ttq.track === "function") {
      window.ttq.track(event, params);
    }
  } catch (e) {
    // silent — analytics must never break UX
    void e;
  }
}

export function ttqPage() {
  try {
    if (typeof window !== "undefined" && window.ttq && typeof window.ttq.page === "function") {
      window.ttq.page();
    }
  } catch (e) { void e; }
}

export function gaEvent(name, params = {}) {
  try {
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("event", name, params);
    }
  } catch (e) { void e; }
}

// Convenience: fire both pixel + GA for a business event.
export function trackEvent(name, params = {}) {
  ttqTrack(name, params);
  gaEvent(name, params);
}
